var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightMirror(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7948 36.8002C21.0304 36.8002 19.6995 36.3425 18.9426 35.4767C18.1281 34.5418 18.0977 33.3229 18.1552 32.6807C18.6666 29.6221 19.4692 26.6221 20.5207 23.9041C22.3427 19.1991 23.2503 18.548 27.9982 18.548C34.1381 18.548 44.4213 22.1087 50.9235 26.4837C52.6642 27.6564 53.0265 29.097 52.1731 31.4548C51.4755 33.3886 49.9566 35.5051 49.1743 36.229C49.0711 36.323 48.4649 36.7896 46.4482 36.8002H22.7948ZM8 40.221L16.3428 50L19.1824 47.447L17.0573 44.9562L22.1168 40.315C22.342 40.3275 22.5554 40.3487 22.7941 40.3487H46.4543C48.7453 40.3381 50.3658 39.8609 51.4139 38.8886C52.6635 37.7355 54.4753 35.108 55.3406 32.7111C57.1372 27.7471 54.9241 24.9617 52.7516 23.4998C45.672 18.7328 34.7995 15 27.9976 15C21.4734 15 19.5448 16.9835 17.3807 22.5702C16.2395 25.5224 15.3708 28.7672 14.7985 32.2179C14.7596 32.6668 14.7731 33.0943 14.7951 33.5166L9.93711 38.3422L8 40.221Z",
    fill: "#C9C9D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMirror);
export default __webpack_public_path__ + "static/media/right-mirror.0aea47230747b2c8753dbabaae3c89d2.svg";
export { ForwardRef as ReactComponent };